import { Reveal, SectionHeading } from "./Reveal";

const CREDENTIALS = [
  "Licence en psychologie du travail",
  "Master 2 — Gestion des ressources humaines",
  "Certifications Sophrologie · Hypnose · EMDR",
  "Formation EFT (Emotional Freedom Techniques)",
  "Formation Méthode Barkley",
];

export default function About() {
  return (
    <section id="apropos" data-testid="about-section" className="relative py-28 lg:py-36 bg-[#0C1526]">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid lg:grid-cols-[0.9fr_1.1fr] gap-16 items-center">
        <Reveal className="relative">
          <div className="absolute -inset-4 rounded-3xl border border-[#D4AF37]/25 translate-x-4 translate-y-4" aria-hidden="true" />
          <div className="relative overflow-hidden rounded-3xl">
            <img
              src="/assets/portrait.jpg"
              alt="Portrait de Frédérique Vasseur"
              data-testid="about-portrait-image"
              className="w-full aspect-[4/5] object-cover grayscale contrast-110 transition-transform duration-[1.5s] ease-out hover:scale-[1.04]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A1120]/70 via-transparent to-transparent" />
            <figcaption className="absolute bottom-5 left-6">
              <p className="font-serif-display text-2xl text-white">Frédérique Vasseur</p>
              <p className="font-mono-accent text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mt-1">
                Consultante · Coach · Thérapeute
              </p>
            </figcaption>
          </div>
        </Reveal>

        <div>
          <SectionHeading
            overtitle="À propos"
            title="Quand le parcours personnel rencontre la vocation."
          />
          <Reveal delay={0.15}>
            <div className="mt-6 space-y-5 text-base sm:text-lg text-slate-400 leading-relaxed">
              <p>
                Pendant plus de vingt ans, j'ai évolué en entreprise — enseignes variées, publics
                différents, échelons gravis — tout en accumulant diplômes et formations en
                psychologie et en accompagnement. Pourtant, quelque chose manquait.
              </p>
              <p>
                La découverte du haut potentiel — d'abord chez mes enfants, puis chez
                moi-même — a tout éclairé. Ce que je vis comme une intensité est devenu ma plus grande
                qualité professionnelle : une capacité rare à comprendre vite, finement,
                et sans jugement les problématiques humaines et organisationnelles.
              </p>
              <p className="text-slate-300">
                Aujourd'hui, ma mission est claire : être pour vous cette personne qui comprend,
                qui écoute, et qui vous aide véritablement à avancer.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.25}>
            <blockquote className="mt-8 border-l-2 border-[#D4AF37]/50 pl-6">
              <p className="font-serif-display text-xl italic text-slate-200 leading-relaxed">
                « Les êtres humains peuvent changer leur vie en modifiant leurs attitudes mentales. »
              </p>
              <cite className="mt-2 block font-mono-accent text-[11px] uppercase tracking-[0.25em] text-[#D4AF37] not-italic">
                — William James
              </cite>
            </blockquote>
          </Reveal>
          <Reveal delay={0.35}>
            <ul className="mt-10 flex flex-wrap gap-3" data-testid="about-credentials-list">
              {CREDENTIALS.map((c) => (
                <li
                  key={c}
                  className="rounded-full border border-[#D4AF37]/25 bg-[#0A1120]/60 px-4 py-2 text-xs sm:text-sm text-slate-300"
                >
                  {c}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
